import { type ReactNode } from 'react';

import './InspectionFieldRow.scss';

interface IInspectionFieldRowProps {
  label: string;
  children: ReactNode;
  isDisabled?: boolean;
}

const InspectionFieldRow = ({ label, children, isDisabled = false }: IInspectionFieldRowProps) => {
  return (
    <div className="inspectionFieldRow">
      <p className={`inspectionFieldRowLabel ${isDisabled ? 'inspectionFieldRowLabelDisabled' : ''}`}>{label}</p>
      <div className="inspectionFieldRowControl">{children}</div>
    </div>
  );
};

export default InspectionFieldRow;
